export const POSTER_ELEMENT_CONTAINER = 'poster-element-container';
export const MOBILE_WHITEBOARD_PADDING = 20;
